import React from "react";

import s from "./border.module.scss";
import { borderColor } from "@moai/core";

interface Props {
    color: keyof typeof borderColor;
}

export const Border = (props: Props) => {
    return <div className={[borderColor[props.color], s.border].join(" ")} />;
};
